import {
  ACTIVE_TASK_COUNT,
  DELETE_TASK_FILTER,
  FILTER_STORE_KEY,
  STORE_TASK_FILTER,
} from '@/store/actions/tasks';
import TaskFilterRequest from '@/mixins/taskFilterMixin';

const getters = {
  /**
   * @description Получить фильтры
   * @returns {TaskFilterRequest}
   */
  getFilter: () => {
    const stored = localStorage.getItem(FILTER_STORE_KEY);
    if (!stored) return new TaskFilterRequest();

    const request = JSON.parse(stored, (key, value) => {
      if ((key === 'createPeriod' || key === 'deadlinePeriod') && Array.isArray(value)) {
        return value.map((item) => (item ? new Date(item) : null));
      }
      return value;
    });
    return new TaskFilterRequest(
      request.authorId,
      request.performerId,
      request.patientId,
      request.roleName,
      request.createPeriod,
      request.deadlinePeriod,
    );
  },
  getActiveTaskCount: (state) => state.activeTaskCount,
};

const actions = {
  /**
   * @description Сохранить фильтр задач
   * @param commit
   * @param {TaskFilterRequest} filter
   */
  [STORE_TASK_FILTER]: ({ commit }, filter) => {
    localStorage.setItem(FILTER_STORE_KEY, JSON.stringify(filter));
    commit(STORE_TASK_FILTER, filter);
  },
  /**
   * @description Сохранить фильтр задач
   * @param commit
   * @param {TaskFilterRequest} filter
   */
  [DELETE_TASK_FILTER]: ({ commit }) => {
    commit(DELETE_TASK_FILTER);
  },
};

const mutations = {
  [ACTIVE_TASK_COUNT]: (state, count) => {
    state.activeTaskCount = count;
  },
  [STORE_TASK_FILTER]: (state, filter) => {
    state.filter = filter;
  },
  [DELETE_TASK_FILTER]: (state) => {
    localStorage.removeItem(FILTER_STORE_KEY);
    state.filter = null;
  },
};

const state = {
  /**
   * @type {TaskFilterRequest}
   */
  filter: new TaskFilterRequest(),
  activeTaskCount: 0,
};

export default () => ({
  getters,
  actions,
  mutations,
  state,
});
